import React, { useState } from "react";
import { motion } from "framer-motion";
import { Lock, ArrowRight } from "lucide-react";
import { useAccess } from "../context/AccessContext";

const EASE = [0.16, 1, 0.3, 1];

export function EmailGate({ nextTitle }) {
  const { submitEmail, error } = useAccess();
  const [value, setValue] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    await submitEmail(value);
    setSubmitting(false);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, ease: EASE }}
      className="max-w-[560px] mx-auto py-16 md:py-24 text-center"
      data-testid="email-gate"
    >
      <div className="inline-flex items-center justify-center w-12 h-12 border-2 border-[#1C2430] mb-6">
        <Lock size={20} className="text-[#1C2430]" />
      </div>
      <div className="font-mono-ui text-[10px] uppercase tracking-[0.24em] text-[#2F6F4F] mb-4">
        The rest is behind one small door
      </div>
      <h2 className="font-serif-display text-[36px] md:text-[46px] leading-[1.0] font-medium text-[#1C2430] mb-5">
        Enter your email to keep going.
      </h2>
      <p className="text-[15px] leading-relaxed text-[#1C2430]/75 mb-8">
        You've read the first three sections for free. Drop your email to unlock the remaining
        chapters, all the interactive drills, and the practice quizzes. No password, no spam,
        just the rest of the guide.
      </p>

      <form onSubmit={onSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto" data-testid="email-gate-form">
        <input
          type="email"
          required
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="you@email.com"
          data-testid="email-gate-input"
          className="flex-1 font-mono-ui text-[14px] bg-white border border-[var(--border-heavy)] px-4 py-3 focus:outline-none focus:border-[#1C2430] placeholder:text-[#1C2430]/35"
        />
        <button
          type="submit"
          disabled={submitting}
          data-testid="email-gate-submit"
          className="font-mono-ui text-[11px] uppercase tracking-[0.16em] bg-[#1C2430] text-[#FBFBF9] px-6 py-3 hover:bg-[#364152] transition-colors inline-flex items-center justify-center gap-2 disabled:opacity-60"
        >
          Unlock <ArrowRight size={14} />
        </button>
      </form>
      {error && (
        <p className="mt-3 font-mono-ui text-[12px] text-[#D26040]" data-testid="email-gate-error">{error}</p>
      )}
      {nextTitle && (
        <p className="mt-8 font-mono-ui text-[10px] uppercase tracking-[0.18em] text-[#1C2430]/40">
          Up next · {nextTitle}
        </p>
      )}
    </motion.div>
  );
}
